import { render, staticRenderFns } from "./ContentEdit.vue?vue&type=template&id=56dc9eaa&scoped=true"
import script from "./ContentEdit.vue?vue&type=script&lang=js"
export * from "./ContentEdit.vue?vue&type=script&lang=js"
import style0 from "./ContentEdit.vue?vue&type=style&index=0&id=56dc9eaa&prod&lang=scss"
import style1 from "./ContentEdit.vue?vue&type=style&index=1&id=56dc9eaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56dc9eaa",
  null
  
)

export default component.exports